import { observable, action, toJS } from "mobx";
import Moment from "moment";
import { Notices } from "constant";

export const TabName = {
  ALL: "all",
  MY: "my",
  PENDING: "pending"
};

export const LivechatRegistrationStore = observable({
  domainName: "http://",
  displayPictureCompanyChannelHandler: "http://",
  companyChannelHandler: 0,
  isDownloaded: false,
  onValidated: true,
  isValidate: "",
  isScriptShow: true,
  script: ``
});

let moduleLoaderResolver = () => {}
export const ModuleLoadedPromise = new Promise((resolve) => {
  moduleLoaderResolver = resolve
})
export const CommonStore = observable({
  me: null,
  workingStart: 0,
  workingEnd: 0,
  responseTimeSLA: 0,
  replyLabelActive: false,
  nickActive: false,
  channelSignatureActive: false,
  autoAssignActive: false,
  csatActive: false,
  serverTime: new Moment(),
  noNeedId: -1,
  allowAgentAssignToOther: true,
  enableTicketing: false,
  enableEmailCampaign: false,
  enableBulkSms: false,
  allowDisableUnassignCase: false,
  moduleLoaded: false
});

export const LivechatOnlineStatusStore = observable({
  originalId: 0,
  isOnline: true
});

export const NotificationStore = observable({
  currentState: {
    type: null,
    message: null
  }
});

export const ServiceAlertStore = observable({
  currentState: {
    isShown: false,
    count: 0,
    message: "",
    pickCase: [],
    case: []
  }
});

export const AnalyticStore = observable({
  companyChannelHandlerList: [],
  channelList: [],
  startTime: Moment().subtract(7, "days"),
  endTime: Moment().add(1, "days"),
  agentList: [],
  granularity: "1 d"
});

export const CustomerJourneyStore = observable({
  // filtering
  activeFilters: ["Customer"],
  filterLabels: [],
  filterStartDate: null,
  filterEndDate: null,
  filterChannel: null,
  filterCustomerField: null
});

export const BillingStore = observable({
  newBilling: []
});

export const CaseHistoryStore = observable({
  // UI state
  selectedCase: null,
  showInfoPanel: false,
  showCloseNotes: true,
  messageScrollBarRef: null,

  // sorting
  sortAsc: true,

  // filtering
  activeFilters: ["Content"],
  filterContent: null,
  filterLabels: [],
  filterStartDate: null,
  filterEndDate: null,
  filterChannel: null,
  filterAgent: null,
  filterCustomerField: null
});

export const CaseManagementStore = observable({
  // UI state
  selectedCase: null,
  showInfoPanel: false,
  messageScrollBarRef: null,

  // case list
  selectedTab: TabName.MY, // all, my, pending
  notifAllCase: false,
  notifMyCase: false,
  notifPendingCase: false,

  // sorting
  allCaseSortAsc: true,
  myCaseSortAsc: true,
  pendingSortAsc: true,

  // filtering
  activeFilters: ["Content"],
  filterContent: null,
  filterLabels: [],
  filterStartDate: null,
  filterEndDate: null,
  filterChannel: null,
  filterAgent: null,
  filterCustomerField: null,

  // reply
  message: "",
  reply: { id: -1, name: "", content: "" },
  replyLabels: [],
  approver: { id: -1, name: "" },
  channelType: { id: -1, name: "", limit: 0 },
  imageUrl: null,

  // edit pending
  editPending: { id: -1, content: "" },

  // for rejection purpose
  rejectPending: { id: -1, content: "" },

  // list of cases from subs
  subsCases: new Map(),

  // list of streams from subs
  subsStreams: new Map()
});

// STORE FUNCTIONS

function getQueryIds(arr) {
  return arr.reduce((sum, value) => sum.concat({ id: value.id }), []);
}

// get analytic module filter
export function GetAnalyticFilter() {
  const store = AnalyticStore;
  const result = {
    companyChannelHandlerList: getQueryIds(store.companyChannelHandlerList),
    channelList: getQueryIds(store.channelList),
    agentList: getQueryIds(store.agentList),
    startTime: store.startTime.format("YYYY-MM-DD"),
    endTime: store.endTime.format("YYYY-MM-DD"),
    granularity: store.granularity
  };
  return result;
}

export function GetCustomerJourneyFilter() {
  const dateFormat = "YYYY-MM-DD";
  const store = CustomerJourneyStore;
  const filter = {
    searchChannel: store.filterChannel ? { id: store.filterChannel.id } : null,
    searchLabels:
      store.filterLabels.length > 0
        ? store.filterLabels.reduce(
            (labels, label) => labels.concat({ id: label.value.id }),
            []
          )
        : null,
    startTime: store.filterStartDate
      ? store.filterStartDate.format(dateFormat)
      : null,
    endTime: store.filterEndDate
      ? store.filterEndDate.format(dateFormat)
      : null,
    searchCustomer: store.filterCustomerField ? store.filterCustomerField : null
  };
  return filter;
}

// get case management or case history filter
export function GetCurrentFilter(history) {
  const dateFormat = "YYYY-MM-DD";
  const store = history ? CaseHistoryStore : CaseManagementStore;
  const filter = {
    agent: store.filterAgent ? { id: store.filterAgent.id } : null,
    searchContent: store.filterContent ? store.filterContent : null,
    searchChannel: store.filterChannel ? { id: store.filterChannel.id } : null,
    searchLabels:
      store.filterLabels.length > 0
        ? store.filterLabels.reduce(
            (labels, label) => labels.concat({ id: label.value.id }),
            []
          )
        : null,
    startTime: store.filterStartDate
      ? store.filterStartDate.format(dateFormat)
      : null,
    endTime: store.filterEndDate
      ? store.filterEndDate.format(dateFormat)
      : null,
    searchCustomer: store.filterCustomerField ? store.filterCustomerField : null
  };
  if (!history) filter.isUnassigned = store.selectedTab === TabName.ALL;
  return filter;
}

// get cases from subs with client side filtering
export function GetFilteredSubsCases() {
  const store = CaseManagementStore;
  const allSubsCases = toJS(store.subsCases);

  // on pending tab, skip filtering cases
  if (store.selectedTab === TabName.PENDING) {
    return allSubsCases;
  } else {
    // prepare filtered rows
    const filtered = {};
    const filterContent = toJS(store.filterContent);
    const filterLabels = toJS(store.filterLabels);
    const filterChannel = toJS(store.filterChannel);
    const filterAgent = toJS(store.filterAgent);
    const filterStartDate =
      store.filterStartDate && Moment(store.filterStartDate);
    const filterEndDate = store.filterEndDate && Moment(store.filterEndDate);
    const filterCustomer = toJS(store.filterCustomerField);
    const hasActiveFilter =
      filterContent ||
      filterLabels.length > 0 ||
      filterChannel ||
      filterAgent ||
      filterStartDate ||
      filterEndDate ||
      filterCustomer;

    if (hasActiveFilter) {
      for (const key in allSubsCases) {
        const value = allSubsCases[key];
        let includeThisCase = false;

        if (filterContent) {
          // filter by content
          if (
            value.lastStream &&
            value.lastStream.content.toLowerCase().indexOf(filterContent) !== -1
          ) {
            includeThisCase = true;
          } else if (
            value.lastPendingStream &&
            value.lastPendingStream.content
              .toLowerCase()
              .indexOf(filterContent) !== -1
          ) {
            includeThisCase = true;
          }
        }

        if (filterLabels) {
          // filter by label
          if (value.lastStream.labels.length > 0) {
            value.lastStream.labels.forEach(item => {
              filterLabels.forEach(label => {
                if (item.labelTemplate.id == label.value.id) {
                  includeThisCase = true;
                }
              });
            });
          }
        }

        if (filterChannel) {
          // filter by channel
          if (value.channel && value.channelHandler.id === filterChannel.id) {
            includeThisCase = true;
          }
        }

        if (filterAgent) {
          // filter by agent
          if (
            value.lastStream &&
            value.lastStream.createdBy &&
            value.lastStream.createdBy.id === filterAgent.id
          ) {
            includeThisCase = true;
          }
        }

        if (filterStartDate && filterEndDate) {
          // filter by date
          const dateUpdated = Moment(value.dateUpdated);
          if (filterStartDate <= dateUpdated && dateUpdated <= filterEndDate) {
            includeThisCase = true;
          }
        }

        if (filterCustomer) {
          // filter by customer
          if (
            value.customerChannelHandler &&
            (value.customerChannelHandler.displayName
              .toLowerCase()
              .indexOf(filterCustomer) !== -1 ||
              value.customerChannelHandler.name
                .toLowerCase()
                .indexOf(filterCustomer) !== -1)
          ) {
            includeThisCase = true;
          }
        }
        console.log(value, includeThisCase)
        console.log("Filter content", filterContent)
        console.log("Filter channel", filterChannel)
        console.log("Filter label", filterLabels)
        console.log("Filter date", filterEndDate, filterStartDate)
        if (includeThisCase) {
          filtered[key] = value;
        }
      }
      return filtered;
    } else {
      // no active filter, then return all collected cases
      return allSubsCases;
    }
  }
}

// get streams from subs
export function GetSubsStreams(caseId) {
  let streams = CaseManagementStore.subsStreams.get(caseId.toString());
  return streams ? toJS(streams) : {};
}

// check if current agent is supervisor
export function IsSupervisor() {
  return CommonStore.me && CommonStore.me.agent.role.name === "supervisor";
}

export function IsAgentAllowedToAssignToOther() {
  if(CommonStore.me) {
    const roleName = CommonStore.me.agent.role.name  
    return roleName == 'agent' && CommonStore.allowAgentAssignToOther || roleName == 'supervisor' 
  } else return false
}

export function isAllowDisableUnassignCase() {
  if(CommonStore.me) {
    const roleName = CommonStore.me.agent.role.name  
    return roleName == 'agent' && CommonStore.allowDisableUnassignCase
  } else return false
}

export const IsTicketingEnabled = action(function() {
  if(CommonStore.me) {
    return CommonStore.enableTicketing
  } else return false
})

export const IsEmailCampaignEnabled = action(function() {
  if(CommonStore.me) {
    return CommonStore.enableEmailCampaign
  } else return false
})

export const  IsBulkSmsEnabled = action(function() {
  if(CommonStore.me) {
    return CommonStore.enableBulkSms
  } else return false
})

export const UpdateCommonStoreConfig = action(function(config) {
  CommonStore.responseTimeSLA = config.responseTimeSLA;
  CommonStore.replyLabelActive = config.replyLabelActive;
  CommonStore.nickActive = config.nickActive;
  CommonStore.channelSignatureActive = config.iconCompanyActive;
  CommonStore.autoAssignActive = config.autoAssignActive;
  CommonStore.csatActive = config.csatActive;
  CommonStore.workingStart = config.workingStart;
  CommonStore.workingEnd = config.workingEnd;
  CommonStore.allowAgentAssignToOther = config.allowAgentAssignToOther       
  CommonStore.enableTicketing = config.enableTicketing 
  CommonStore.enableEmailCampaign = config.enableEmailCampaign
  CommonStore.enableBulkSms = config.enableBulkSms
  CommonStore.allowDisableUnassignCase = config.allowDisableUnassignCase
  CommonStore.moduleLoaded = true
  moduleLoaderResolver()
})

export const ReplyStream = action(function(id, name, content, channelTypeId) {
  const store = CaseManagementStore;
  store.reply = { id, name, content };
  ResetChannelType(channelTypeId)
});

// change tab in case management module
export const ChangeTab = action(function(tabName) {
  const store = CaseManagementStore;

  // early return if we dont change tab name
  if (store.selectedTab === tabName) return;

  // clear notif on selected tab
  store.selectedTab = tabName;
  if (tabName === TabName.ALL) {
    store.notifAllCase = false;
  } else if (tabName === TabName.MY) {
    store.notifMyCase = false;
    store.filterLabels = [];
  } else if (tabName === TabName.PENDING) {
    store.notifPendingCase = null;
  }
  // clear case selection
  //SelectCase(null);
});

// select case in case management module
export const SelectCase = action(function(selected) {
  const store = CaseManagementStore;
  const prevSelected = store.selectedCase;
  store.selectedCase = selected;

  const changed =
    (selected === null && prevSelected !== null) ||
    (selected !== null && prevSelected === null) ||
    (selected && prevSelected && selected.id !== prevSelected.id);

  // reset states on change case
  if (changed) {
    ResetMessage();
    ResetChannelType();
  }  
});

const ResetChannelType = action(function(selectedSpecificTypeId) {
  const store = CaseManagementStore;
  const selected = store.selectedCase;
  store.channelType = { id: -1, name: "", limit: 0 };
  if (selected) {
    const lastStreamTypeId = selectedSpecificTypeId || (selected.lastStream ? selected.lastStream.specificTypeId.id : null);
    const selectedType = selected.channel.channelSpecificType.find(
      chType => chType.id === lastStreamTypeId
    );
    if (selectedType) {
      store.channelType = {
        id: selectedType.id,
        name: selectedType.name,
        limit: selectedType.charLimit
      };
    }
  }
});

export const ResetMessage = action(function() {
  const store = CaseManagementStore;
  const selected = store.selectedCase;
  store.message = "";
  store.approver = { id: -1, name: "" };
  store.reply = { id: -1, name: "", content: "" };
  store.imageUrl = null;
  store.editPending = { id: -1, content: "" };
  store.replyLabels.clear();
  const userTwitter = CaseManagementStore;
  userTwitter.user = "";
  store.rejectPending = { id: -1, content: "" };
  //let UserLength = "";
  //CaseManagementStore.message = text;
  // if selectead case from twitter channel, add premade text
  if (selected && selected.channel.name === "twitter") {
    userTwitter.user = `@${selected.customerChannelHandler.displayName}`;
    // store.message = `@${selected.customerChannelHandler.displayName}`;
    store.message = "";
  } else if (selected && selected.channel.name === "instagram") {
    store.message = `@${selected.customerChannelHandler.displayName} `;
  }
});

export const UpdateServerTime = action(function(time) {
  const store = CommonStore;
  store.serverTime = new Moment(time);
});

export const TickServerTime = action(function(diff) {
  const store = CommonStore;
  store.serverTime = store.serverTime.add(diff, "seconds").clone();
});

export const ShowNotice = action(function(noticeName, overrideMessage) {
  const notice = Notices[noticeName];

  if (notice) {
    NotificationStore.currentState = {
      type: notice.type,
      message: notice.message
    };
  } else {
    NotificationStore.currentState = {
      type: "error",
      message: "Unknown Error"
    };
  }

  if (overrideMessage) {
    NotificationStore.currentState.message = overrideMessage;
  }
});



// WEBPACK FOOTER //
// ./src/Store.js